export default __webpack_public_path__ + "static/media/codemy-book.12724465.png";